import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AppSettingsService } from "../../../core";
import { Observable } from "rxjs";
import { BucketList } from "../models/bucket.model";
import { IBucketToTransfer } from "../../bucket-items/models/bucket-to-transfer.model";
import { IDestinationBucketListRequest } from "../../bucket-items/models/destination-bucket-list-request.model";

@Injectable({
  providedIn: "root",
})
export class BucketsService {
  private http = inject(HttpClient);
  private appSettings = inject(AppSettingsService);

  private readonly baseUrl = `${this.appSettings.baseApiUrl}/api/Buckets`;

  public GetBucketList(): Observable<BucketList[]> {
    return this.http.get<BucketList[]>(
      `${this.baseUrl}/get-user-relevant-bucket-list`
    );
  }

  public GetDestinationDataForTransfer(destionationBucketListRequest: IDestinationBucketListRequest): Observable<IBucketToTransfer[]> {
    const url =`${this.baseUrl}/get-bucket-to-transfer`;
    return this.http.post<IBucketToTransfer[]>(url, destionationBucketListRequest);
  }

}
